import { formatGQLDate } from "@/lib/formatters/DateFormatter";
import { HeadAgreementStatusCode } from "@/gql/graphql";
import { HeadAgreement } from "../types";
export const getIdsForRouteAgreementsToPrefill = (
  headAgreement: HeadAgreement
): Array<string> => {
  return headAgreement.routeAgreements
    .filter((r) => {
      return (
        formatGQLDate(r.valid.end) === formatGQLDate(headAgreement.valid.end) &&
        !r.multiLegAgrRouteId &&
        r.statusCode === HeadAgreementStatusCode.Active
      );
    })
    .map((r) => r.id);
};
